import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Dashboard() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="container-custom"><p>Loading...</p></div>;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/dashboard/login" replace />;
  }

  return (
    <div className="dashboard-container">
      <div className="container-fluid">
        <Outlet />
      </div>
    </div>
  );
}

export default Dashboard;
